import { ResourceTabs } from "@/components/ResourceTabs";
import type { DashboardKind } from "@/lib/dashboard/types";

export function DashboardResourceTabs({ kind }: { kind: DashboardKind }) {
  return (
    <ResourceTabs
      label="Workspace views"
      value={kind}
      items={[
        { value: "dashboard", label: "Dashboards", to: "/workspace/dashboards" },
        { value: "template", label: "Templates", to: "/workspace/dashboards?view=templates" },
      ]}
    />
  );
}
